import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { Form, FormGroup } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";

import Button from "../../../../components/common/button/Button";
import Input from "../../../../components/common/input/Input";
import Select2 from "../../../../components/common/select/Select2";
import styles from "./AdminCompanyManager.scss";

import {
  alphaSymbolicSpace,
  dropdown,
  email,
  required
} from "../../../../utils/forms/validators";

export const emailValidation = msg => email(msg);
const alphaSymbolicSpaceValidation = msg => alphaSymbolicSpace(msg);

export const emailVal = emailValidation("Please enter a valid email address.");
const firstName = alphaSymbolicSpaceValidation(
  "Please enter a valid first name."
);
const lastName = alphaSymbolicSpaceValidation(
  "Please enter a valid last name."
);
const dropdownValidation = dropdown("Please select an option.");

class AdminCompanyManager extends Component {
  constructor(props) {
    super(props);
  }

  renderOptions(options, types) {
    const preferences = types.map(type => (
      <Row key={type.slug} className={styles.row}>
        <Col xs={12} sm={6} className={styles.rowLeft}>
          {type.value}
        </Col>
        <Col xs={12} sm={6} className={styles.rowRight}>
          <Field
            name={type.slug}
            type="select"
            placeholder="Options"
            component={Select2}
            options={options}
            validate={dropdownValidation}
          />
        </Col>
      </Row>
    ));

    return preferences;
  }

  render() {
    const { submitting, valid, options, types } = this.props;
    return (
      <section className={styles.settings}>
        <div className={styles.content}>
          <h2 className={styles.title}>Basics</h2>

          <Form onSubmit={this.props.handleSubmit}>
            <div className={styles.form}>
              <FormGroup>
                <Row>
                  <Col md={12} xs={12}>
                    <Field
                      name="first_name"
                      type="text"
                      placeholder="First Name"
                      component={Input}
                      validate={[required, firstName]}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={12} xs={12}>
                    <Field
                      name="last_name"
                      type="text"
                      placeholder="Last Name"
                      component={Input}
                      validate={[required, lastName]}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={12} xs={12}>
                    <Field
                      name="email"
                      type="text"
                      placeholder="Email Address"
                      component={Input}
                      validate={[required, emailVal]}
                    />
                  </Col>
                </Row>
              </FormGroup>

              <div className={styles.divider} />
              <div className={styles.sectionTitle}>Email Preferences</div>

              <FormGroup className={styles.formGroup}>
                {this.renderOptions(options, types)}
              </FormGroup>

              <div className={styles.divider} />

              <Button
                isPrimary
                type="submit"
                size={"large"}
                noMarginBottom
                label="Save Changes"
                isDisabled={!valid || submitting}
              />
            </div>
          </Form>
        </div>
      </section>
    );
  }
}

AdminCompanyManager = reduxForm({
  form: "basicsForm",
  enableReinitialize: true,
  touchOnBlur: true,
  touchOnChange: true
})(AdminCompanyManager);

AdminCompanyManager = connect((props, state) => {
  const user = state.user;
  const types = state.types;

  let initialValues = { ...user };
  if (types.length > 0) {
    types.forEach(function(type) {
      const email_preferences = _.get(user, "email_preferences");

      if (email_preferences) {
        const option = email_preferences.filter(
          option => option.type_id && option.type_id === type.id
        );

        if (option) {
          const value = { [`${type.slug}`]: _.first(option).option_id };
          initialValues = { ...initialValues, ...value };
        }
      }
    });
  }

  return {
    initialValues,
    user: props.user,
    saving: state.user.loading
  };
})(AdminCompanyManager);

export default AdminCompanyManager;



// WEBPACK FOOTER //
// ./src/routes/admin/company/components/AdminCompanyManager.js